angular.module('unergie.main')
.directive('landscape', ($q, ApiUser, MetaWatcher, ContractService) => ({
    restrict: 'E',
    scope: {
        contract: '=',
    },
    templateUrl: '/directives/landscape/landscape.html',
    link($scope) {
        $scope.search = {
            answer: undefined,
            label: undefined,
            id_func: undefined,
            answer_func: undefined,
            id: undefined,
        }
        const versionMapping = {
            'v1-full': 'v1',
            'v2-light': 'v2',
        }

        const getLandscape = (contract) => {
            ApiUser.searchLandscape({ idContract: contract.id, draft: false, format: 'display' }).$promise.then((landscapeSearchResult) => {
                const arrayWithId = (values) => _.values(_.mapValues(values, (value, key) => _.assign({}, value, { id: key })))
                $scope.landscapeSearch = _.assign({}, landscapeSearchResult, {
                    version: _.get(versionMapping, landscapeSearchResult.version, landscapeSearchResult.version),
                    surveyArray: arrayWithId(landscapeSearchResult.survey),
                    equipmentsArray: arrayWithId(landscapeSearchResult.equipments),
                })
                $scope.contract.landscapeDone = !!$scope.landscapeSearch.surveyArray.length
            }).catch((response) => {
                if (response.status === 404) {
                    $scope.landscapeSearch = null
                }
            })
        }

        if ($scope.contract) {
            MetaWatcher.watch('CONTRACT_CHANGED', 'landscape', $scope, getLandscape)
            getLandscape($scope.contract)
        } else {
            ContractService.watch('landscapeWatcher', getLandscape)
        }
    },
}))
